import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=15fb1b12"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=15fb1b12&prod&lang=scss"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=15fb1b12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports